import { StyleSheet } from 'react-native';

import ResponsiveDimensionValues from '../../../../components/common/responsive-dimension-values';

const CHART_PADDING = 110;

export const getAdaptiveWidth = function (width, isHalfScreen) {
  return width * (isHalfScreen ? 0.43 : 1);
}

export const getChartRadius = function (width, screenWidth) {
  return screenWidth > 640 ? (width - CHART_PADDING * 2 - 65) / 3 : width / 2.8;
}

const WINDOW_WIDTH = getAdaptiveWidth(ResponsiveDimensionValues.windowWidth,
  ResponsiveDimensionValues.windowWidth >= 640);

const CHART_RADIUS = getChartRadius(WINDOW_WIDTH);

const PADDING_HORIZONTAL = (WINDOW_WIDTH - ((CHART_PADDING + CHART_RADIUS) * 2)) / 2;

export default StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#12213c',
    marginEnd: '15px',
    marginBottom: '10px'
  },
  wrapper: {
    marginTop: 5,
  },
  label: {
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 5,
    position: 'absolute',
    top: CHART_RADIUS + CHART_PADDING - 30,
    left: WINDOW_WIDTH / 2 - PADDING_HORIZONTAL - 75,
    width: 150,
  },
  labelDetails: {
    alignItems: 'center',
    flex: 1,
  },
  labelName: {
    // lineHeight: TYPOGRAPHY.font.size.small + 2,
  },
  labelValue: {
    // lineHeight: TYPOGRAPHY.font.size.large + 4,
  },
  instruction: {
    bottom: 15,
    left: 0,
    position: 'absolute',
    width: (CHART_RADIUS + CHART_PADDING) * 2,
  },
  instructionText: {
    textAlign: 'center',
  },
});

export const chartSVGStyles = {
  root: {
    radius: CHART_RADIUS + CHART_PADDING,
    padding: CHART_PADDING,
  },
  firstBar: {
    marginRight: 0,
  },
};
